import { useQuery } from "@tanstack/react-query";
import { listClearanceMetadata } from "../../../../api/routes";
import { ReportClearanceEntry } from "../../../../client";
import { clearanceKeys } from "../../queryKeys";
import { createBatcher } from "../../rater/batcher";

const clearanceBatcher = createBatcher(async (reportIds: string[]) => {
  const entries = await listClearanceMetadata(reportIds);
  return new Map(entries.map((entry) => [entry.report_id, entry]));
}, 50);

/**
 * The stored fix_sov / clearance-review results for one report. The endpoint is
 * admin-only, so pass `enabled: false` for everyone else. A report with no
 * automation history resolves to `null`.
 */
export function useClearanceMetadata(reportId: string, enabled: boolean) {
  return useQuery<ReportClearanceEntry | null>({
    queryKey: clearanceKeys.metadata(reportId),
    queryFn: () =>
      clearanceBatcher.load(reportId).then((entry) => entry ?? null),
    enabled,
    // Results change only when a job finishes; the in-flight state comes from
    // the faster report-jobs poll, so this can be slower.
    refetchInterval: 15000,
  });
}
